import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Section } from '../components/Section';
export function Terms() {
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-744">
      <Navbar data-id="element-745" />
      <main className="flex-grow" data-id="element-746">
        <Section className="pt-32 md:pt-48" data-id="element-747">
          <div className="max-w-4xl mx-auto" data-id="element-748">
            <h1 className="font-poppins font-normal text-3xl md:text-4xl text-black mb-4" data-id="element-749">
              HiddenMatter Website Terms of Use
            </h1>
            <p className="font-inter text-base text-black mb-8" data-id="element-750">
              Effective Date: 7 April 2026
            </p>
            <div className="space-y-8 font-inter text-base leading-relaxed text-black" data-id="element-751">
              <p data-id="element-752">
                This Agreement is legally binding between Visitor and
                HiddenMatter, together with any subsidiaries and affiliates
                (collectively, "HiddenMatter," "we," "our," or "us"). As used
                here, "Visitor" or "You" means any entity or natural person who
                visits, accesses, or otherwise interacts with the
                HiddenMatter.ai or any other affiliated website to which these
                Terms are posted (the "Sites"). All content contained on the
                Sites, and all versions, updates, corrections, enhancements, and
                modifications thereof (collectively, the "Services") available
                to Visitor for Visitor's use are subject to these Terms.
              </p>
              <p data-id="element-753">
                In addition, when using particular Services, Visitor may be
                subject to any guidelines or rules applicable to such Services
                which may be posted on the Sites or directly provided to Visitor
                from time to time. All such guidelines or rules are hereby
                incorporated by reference into the Terms. HiddenMatter also may
                offer other services from time to time that are governed by
                different terms.
              </p>
              <p data-id="element-754">
                By accessing and using the Services, Visitor agrees to be bound
                by the terms and conditions of this Agreement.
              </p>
              <div className="pt-4" data-id="element-755">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-756">
                  1. Changes to the Terms
                </h2>
                <p data-id="element-757">
                  HiddenMatter reserves the right to change or modify the Terms
                  at its sole discretion at any time. If Visitor does not agree
                  to the modified Terms, Visitor should discontinue use of the
                  Services. Otherwise, Visitor's continued use of the Services
                  will constitute their acceptance. Therefore, it is important
                  that Visitor monitor the Sites regularly to ensure Visitor is
                  familiar with the most updated Agreement. UNLESS OTHERWISE
                  STATED, ANY CHANGES TO THIS AGREEMENT WILL APPLY IMMEDIATELY
                  UPON POSTING. Any changes will not apply retroactively.
                </p>
              </div>
              <div className="pt-4" data-id="element-758">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-759">
                  2. SERVICES
                </h2>
                <div className="space-y-4" data-id="element-760">
                  <div data-id="element-761">
                    <p className="font-medium mb-2" data-id="element-762">a) The Services.</p>
                    <p data-id="element-763">
                      HiddenMatter currently provides Visitors to the Sites with
                      access to information about its products and services.
                      Unless explicitly stated otherwise, any new features that
                      augment or enhance the current Services shall be subject
                      to the Terms.
                    </p>
                  </div>
                  <div data-id="element-764">
                    <p className="font-medium mb-2" data-id="element-765">
                      b) Right to Access and Use.
                    </p>
                    <p data-id="element-766">
                      Subject to all the terms and conditions of this Agreement,
                      HiddenMatter hereby grants to Visitor a non-exclusive,
                      non-sublicensable, non-transferable, revocable, and
                      limited basis, a license to access and use the Services.
                      Accessing and using the Services may include downloading
                      or viewing files or other information from the Sites
                      ("Materials"). The Materials may be used by Visitor only
                      subject to these Terms. All rights not expressly granted
                      are reserved by HiddenMatter and, if applicable, its
                      third-party providers.
                    </p>
                  </div>
                  <div data-id="element-767">
                    <p className="font-medium mb-2" data-id="element-768">c) Modification.</p>
                    <p data-id="element-769">
                      We may modify, discontinue, restrict, or alter,
                      temporarily or permanently, any aspect of the Services at
                      our sole discretion and without prior notice or liability
                      to Visitor. We may also install bug fixes, patches, and
                      other upgrades to the Services without prior notice to
                      Visitor. Visitor's only remedy is to discontinue using the
                      Services in the event Visitor does not want a modification
                      we make to the Services.
                    </p>
                  </div>
                </div>
              </div>
              <div className="pt-4" data-id="element-770">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-771">
                  3. VISITOR Obligations and Restrictions
                </h2>
                <div className="space-y-4" data-id="element-772">
                  <div data-id="element-773">
                    <p className="font-medium mb-2" data-id="element-774">a) General Obligations:</p>
                    <p data-id="element-775">
                      By entering into this Agreement, Visitor agrees that: (i)
                      Visitor will comply with the terms and conditions of this
                      Agreement and all applicable laws, rules, and regulations,
                      including laws regarding the transmission of technical
                      data exported from the United States or the country in
                      which Visitor is located; (ii) Visitor's access to and use
                      of any part of our Services will not constitute a breach
                      or violation of any other agreement, contract, terms of
                      use, or any law or regulation to which Visitor is subject;
                      (iii) Visitor will immediately notify us once Visitor
                      learns or suspects any unauthorized use of the Services;
                      (iv) Visitor will not use our Services in order to gain
                      competitive intelligence about us, our Services, or any
                      product or service offered via our Services or to
                      otherwise compete with us; and (v) Visitor's Content and
                      Feedback (as defined below) will not violate the rights of
                      any third party, including, without limitation, the
                      intellectual property, privacy, or publicity rights of any
                      third party, or Visitor otherwise has all rights and
                      permissions required to submit Content and Feedback to us.
                      Visitor represents and warrants that it has the power and
                      authority to enter into and perform its obligations under
                      this Agreement.
                    </p>
                  </div>
                  <div data-id="element-776">
                    <p className="font-medium mb-2" data-id="element-777">b) Registration.</p>
                    <p data-id="element-778">
                      In consideration of Visitor's use of the Services, Visitor
                      agrees to: (i) provide true, accurate, current, and
                      complete information as prompted by any registration form
                      on the Sites (such information being the "Registration
                      Data"); and (ii) maintain and promptly update the
                      Registration Data to keep it true, accurate, current, and
                      complete. If Visitor provides any information that is
                      untrue, inaccurate, not current, or incomplete, or we have
                      reasonable grounds to suspect that such information is
                      untrue, inaccurate, not current, or incomplete,
                      HiddenMatter has the right to suspend or terminate this
                      Agreement and refuse any and all current or future use of
                      the Services (or any portion thereof).
                    </p>
                  </div>
                  <div data-id="element-779">
                    <p className="mb-2" data-id="element-780">
                      c) Visitor understands that all information, data, text,
                      software, music, sound, photographs, graphics, video,
                      messages, or other materials ("Content"), whether publicly
                      posted or privately transmitted, are the sole
                      responsibility of the person from which such Content
                      originated. This means that Visitor, and not HiddenMatter,
                      is entirely responsible for all Content that Visitor and
                      its authorized users upload, post, email, or otherwise
                      transmit via the Services. HiddenMatter does not
                      pre-screen Content before it is uploaded or transmitted,
                      so HiddenMatter does not guarantee the accuracy,
                      integrity, or quality of such Content and will not be
                      liable for any errors, omissions, or loss or damages as a
                      result of using such Content. However, HiddenMatter
                      reserves the right (but not the obligation) in its sole
                      discretion to remove any Content that is made available
                      via the Services, that violates these Terms, or is
                      otherwise objectionable. We shall have no liability to
                      Visitor if we take such action. Subject to the foregoing,
                      Visitor further agrees not to use the Services, and will
                      not permit any third parties or any of its authorized
                      users, to:
                    </p>
                    <ul className="list-none space-y-2 ml-4" data-id="element-781">
                      <li data-id="element-782">
                        3.c.1. sublicense, lease, rent, loan, or otherwise
                        transfer to any third party any of Visitor's rights
                        under these Terms to access or use the Services or make
                        the Services available to or for the benefit of any
                        third party;
                      </li>
                      <li data-id="element-783">
                        3.c.2. use the Services to develop, or assist a third
                        party in developing, a competing or similar service or
                        product;
                      </li>
                      <li data-id="element-784">
                        3.c.3. access the Services by any means other than
                        through the interface that is provided for use in
                        accessing the Services;
                      </li>
                      <li data-id="element-785">
                        3.c.4. upload, post, email, or otherwise transmit any
                        Content that is unlawful; harmful; threatening; abusive;
                        harassing; tortious; defamatory; vulgar; obscene;
                        libelous; invasive of another's privacy; hateful,
                        racially or ethnically, or otherwise objectionable; spam
                        content or communications; or other forms of
                        solicitation;
                      </li>
                      <li data-id="element-786">
                        3.c.5. harm minors in any way, or "stalk" or otherwise
                        harass another;
                      </li>
                      <li data-id="element-787">
                        3.c.6. impersonate any person or entity, misrepresent
                        Visitor's affiliation with a person or entity, or
                        manipulate identifiers in order to disguise the origin
                        of any Content transmitted through the Services;
                      </li>
                      <li data-id="element-788">
                        3.c.7. upload, post, email, or otherwise transmit any
                        Content that Visitor does not have a right to transmit
                        under any law, contractual or fiduciary relationships,
                        or which otherwise infringes any patent, trademark,
                        trade secret, copyright, or other intellectual property
                        or proprietary rights of HiddenMatter or any third
                        party;
                      </li>
                      <li data-id="element-789">
                        3.c.8. upload, post, email, or otherwise transmit any
                        material that contains software viruses, harmful or
                        malicious code, or any other computer code, files, or
                        programs that causes or is designed to interrupt,
                        destroy, or limit in any way the functionality of any
                        data, computer software, hardware, or telecommunications
                        equipment of the Services, or to allow any other third
                        party to access, damage, or corrupt any data, storage,
                        media, program, equipment, or communications of the
                        Services;
                      </li>
                      <li data-id="element-790">
                        3.c.9. violate applicable laws, ordinances, or
                        regulations or otherwise use the Services for any
                        unlawful purpose;
                      </li>
                      <li data-id="element-791">
                        3.c.10. remove or modify any program markings or
                        identification, proprietary, copyright, or other notice
                        of HiddenMatter's or its licensors' proprietary rights
                        contained in the Services;
                      </li>
                      <li data-id="element-792">
                        3.c.11. modify, adapt, alter, translate, or create
                        derivative works from the Services or reverse engineer,
                        decompile, disassemble, or otherwise attempt to derive
                        the source code for the Services;
                      </li>
                      <li data-id="element-793">
                        3.c.12. reproduce, duplicate, copy, record, broadcast,
                        sell, resell, or exploit for commercial or personal
                        purposes, any portion of the Services, use of the
                        Services, or access to the Services;
                      </li>
                      <li data-id="element-794">
                        3.c.13. collect or store personal data about other
                        Visitors.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="pt-4" data-id="element-795">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-796">
                  4. Intellectual Property
                </h2>
                <div className="space-y-4" data-id="element-797">
                  <div data-id="element-798">
                    <p className="font-medium mb-2" data-id="element-799">a) Ownership.</p>
                    <p data-id="element-800">
                      At all times, HiddenMatter, its affiliates, or third-party
                      licensors exclusively own and hold all right, title, and
                      interest in and to the Services, including without
                      limitation, all intellectual property contained therein,
                      and all materials related to the Services and all
                      intellectual property derived from the Services. This
                      includes, but is not limited to, systems, databases,
                      documents, content, methods, processes, hardware, software
                      (including source and object code), ideas, inventions,
                      discoveries, derivative works, enhancements, upgrades,
                      fixes and patches, and all images, trademarks, service
                      marks, logos, and icons displayed or related therein or
                      thereto. Except as expressly provided in these Terms,
                      Visitor has no right, license, or authorization with
                      respect to any of the Services or material contained
                      therein. Visitor shall not remove, alter, or obscure any
                      trademarks or logos or any proprietary notices contained
                      in the Services or any other material provided by
                      HiddenMatter. Visitor shall not assert any claims to the
                      contrary or otherwise do anything inconsistent with
                      HiddenMatter's ownership rights. In the event Visitor is
                      ever deemed to be the owner of any of the Services or
                      materials derived therefrom, Visitor shall immediately
                      take all necessary steps to evidence, transfer, perfect,
                      vest, or confirm HiddenMatter's right, title, and interest
                      in such material.
                    </p>
                  </div>
                  <div data-id="element-801">
                    <p className="font-medium mb-2" data-id="element-802">b) Feedback.</p>
                    <p data-id="element-803">
                      We welcome Visitor comments, feedback, information, or
                      materials regarding the Services (collectively,
                      "Feedback"). By submitting Feedback to us, Visitor agrees
                      to assign, and hereby irrevocably assign to us, all right,
                      title, and interest in and to the Feedback and all
                      copyrights and other intellectual property rights embodied
                      in such Feedback on a worldwide basis. We may use, copy,
                      distribute, publish, and modify Feedback on an
                      unrestricted basis, without compensation to Visitor.
                    </p>
                  </div>
                </div>
              </div>
              <div className="pt-4" data-id="element-804">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-805">
                  5. GENERAL PRACTICES REGARDING USE AND STORAGE
                </h2>
                <p data-id="element-806">
                  Visitor acknowledges that HiddenMatter may establish general
                  practices and limits concerning use of the Services, including
                  without limitation the maximum disk space that will be
                  allotted on HiddenMatter servers on Visitor's behalf and the
                  maximum number of times (and the maximum duration for which)
                  Visitor may access the Services in a given period of time.
                  Visitor agrees that HiddenMatter has no responsibility or
                  liability for the deletion or failure to store any messages
                  and other communications or other Content maintained or
                  transmitted by the Services. Visitor further acknowledges that
                  HiddenMatter reserves the right to change these general
                  practices and limits at any time, in its sole discretion, with
                  or without notice.
                </p>
              </div>
              <div className="pt-4" data-id="element-807">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-808">
                  6. SURVIVAL
                </h2>
                <p data-id="element-809">
                  The following sections shall survive the termination or
                  expiration of this Agreement: 3 (Visitor Obligations and
                  Restrictions), 4 (Intellectual Property), 6 (Survival), 7
                  (Links), 9 (Indemnification), 10 (Disclaimer of Warranties),
                  11 (Limitation of Liability), 12 (Dispute Resolution), and 13
                  (General Information).
                </p>
              </div>
              <div className="pt-4" data-id="element-810">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-811">
                  7. LINKS
                </h2>
                <p data-id="element-812">
                  The Services may provide, or third parties may provide, links
                  to other websites or resources. Because HiddenMatter has no
                  control over such sites and resources, Visitor acknowledges
                  and agrees that HiddenMatter is not responsible for the
                  availability of such external sites or resources and does not
                  endorse and is not responsible or liable for any information,
                  advertising, products, or other materials on or available from
                  such sites or resources. Visitor further acknowledges and
                  agrees that HiddenMatter shall not be responsible or liable,
                  directly or indirectly, for any damage or loss caused or
                  alleged to be caused by or in connection with use of or
                  reliance on any such information, goods or services available
                  on or through any such site or resource.
                </p>
              </div>
              <div className="pt-4" data-id="element-813">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-814">
                  8. System Availability and Errors
                </h2>
                <p className="mb-4" data-id="element-815">
                  Visitor must provide the equipment and Internet connections
                  necessary to access the Services at Visitor's own expense. We
                  do not guarantee that the Services will operate with Visitor's
                  computers, mobile devices, internet service plans, or mobile
                  provider service plans, or with any particular computer or
                  other piece of hardware, software, equipment, or device.
                </p>
                <p className="mb-4" data-id="element-816">
                  There may be times when the Services are unavailable due to
                  technical errors or for maintenance and support activities. We
                  do not represent, warrant, or guarantee that the Services will
                  always be available or are completely free of human or
                  technological errors.
                </p>
                <p data-id="element-817">
                  The Services may contain typographical mistakes, inaccuracies,
                  or omissions, and some information may not be complete or
                  current. We expressly reserve the right to correct any errors,
                  inaccuracies, or omissions and to change or update information
                  at any time without prior notice. We do not make any
                  representation or warranty concerning errors, omissions,
                  delays, or defects in the Services or any information supplied
                  to Visitor via the Services, or that files available through
                  Services are free of viruses, worms, Trojan horses, or other
                  code that include or manifest contaminating or destructive
                  characteristics.
                </p>
              </div>
              <div className="pt-4" data-id="element-818">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-819">
                  9. Indemnification
                </h2>
                <p data-id="element-820">
                  Visitor agrees to indemnify, defend, and hold harmless
                  HiddenMatter and its affiliates, officers, agents, employees,
                  and assignees ("HiddenMatter Parties") from any and all
                  claims, liabilities, expenses and damages, including
                  reasonable attorneys' fees and costs, made by any third party
                  relating to or arising out of: (a) Visitor's use or attempted
                  use of the Services or any Content contained therein; (b)
                  Visitor's violation of any law or rights of any third party;
                  (c) Content that Visitor or any of its authorized users post
                  or otherwise make available on the Services, including without
                  limitation any claim of infringement or misappropriation of
                  intellectual property or other proprietary rights; and (d) any
                  act or omission by Visitor that constitutes a breach of
                  Visitor's obligations under this Agreement.
                </p>
              </div>
              <div className="pt-4" data-id="element-821">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-822">
                  10. DISCLAIMER OF WARRANTIES
                </h2>
                <p className="mb-4" data-id="element-823">
                  VISITOR'S USE OF THE SERVICES IS AT VISITOR'S SOLE RISK. THE
                  SERVICES ARE PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS.
                  VISITOR must evaluate, and bear all risks associated with, the
                  use of any Content, including any reliance on the accuracy,
                  completeness, or usefulness of such Content.
                </p>
                <p className="mb-4" data-id="element-824">
                  HIDDENMATTER EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND,
                  WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO THE
                  IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
                  PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
                </p>
                <p className="mb-4" data-id="element-825">
                  HIDDENMATTER MAKES NO WARRANTY THAT (I) THE SERVICES WILL MEET
                  VISITOR'S REQUIREMENTS; (II) THE SERVICES WILL BE
                  UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE; (III) THE
                  RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE SERVICES WILL
                  BE ACCURATE OR RELIABLE; (IV) THE QUALITY OF ANY PRODUCTS,
                  SERVICES, INFORMATION, OR OTHER MATERIAL PURCHASED OR OBTAINED
                  BY VISITOR THROUGH THE SERVICES WILL MEET VISITOR'S
                  EXPECTATIONS; AND (V) ANY ERRORS IN THE SERVICES WILL BE
                  CORRECTED.
                </p>
                <p className="mb-4" data-id="element-826">
                  ANY MATERIAL ACCESSED, DOWNLOADED, OR OTHERWISE OBTAINED
                  THROUGH THE USE OF THE SERVICES IS DONE AT VISITOR'S OWN
                  DISCRETION AND RISK, AND VISITOR WILL BE SOLELY RESPONSIBLE
                  FOR ANY DAMAGE TO VISITOR'S COMPUTER SYSTEMS OR LOSS OF DATA
                  THAT RESULTS FROM THE ACCESS TO, DOWNLOADING OF, OR OTHERWISE
                  OBTAINING ANY SUCH MATERIAL.
                </p>
                <p data-id="element-827">
                  NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY
                  VISITOR FROM HIDDENMATTER OR THROUGH OR FROM THE SERVICES
                  SHALL CREATE ANY WARRANTY NOT EXPRESSLY STATED IN THE TERMS.
                </p>
              </div>
              <div className="pt-4" data-id="element-828">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-829">
                  11. LIMITATION OF LIABILITY
                </h2>
                <p data-id="element-830">
                  TO THE FULLEST EXTENT PERMISSIBLE BY LAW, HIDDENMATTER OR
                  HIDDENMATTER PARTIES SHALL NOT BE LIABLE TO VISITOR OR ANY
                  THIRD PARTY FOR ANY INDIRECT, INCIDENTAL, PUNITIVE, SPECIAL,
                  CONSEQUENTIAL, OR EXEMPLARY DAMAGES, INCLUDING BUT NOT LIMITED
                  TO, DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA, OR OTHER
                  INTANGIBLE LOSSES (EVEN IF HIDDENMATTER HAS BEEN ADVISED OF
                  THE POSSIBILITY OF SUCH DAMAGES), ARISING OUT OF OR RESULTING
                  FROM: (I) THE USE OR THE INABILITY TO USE THE SERVICES; (II)
                  VISITOR'S OR ITS AUTHORIZED USERS' PLACEMENT OF CONTENT
                  THROUGH THE SERVICES; (III) UNAUTHORIZED ACCESS TO OR
                  ALTERATION OF VISITOR'S CONTENT, TRANSMISSIONS, OR DATA; (IV)
                  STATEMENTS OR CONDUCT OF ANY THIRD PARTY USING OR ACCESSING
                  THE SERVICES; OR (IV) ANY OTHER MATTER RELATING TO THE
                  SERVICE, WHETHER BASED IN CONTRACT, TORT, STATUTORY, OR OTHER
                  LAW. TO THE FULLEST EXTENT PERMISSIBLE BY LAW, IN NO EVENT
                  SHALL HIDDENMATTER'S TOTAL LIABILITY TO VISITOR OR THIRD PARTY
                  IN CONNECTION WITH THIS AGREEMENT, THE SERVICES, OR ANY OTHER
                  RELATED SERVICES EXCEED ONE HUNDRED U.S. DOLLARS ($100.00).
                  THE EXISTENCE OF MULTIPLE CLAIMS DOES NOT ENLARGE THIS LIMIT.
                </p>
              </div>
              <div className="pt-4" data-id="element-831">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-832">
                  12. Dispute Resolution
                </h2>
                <p data-id="element-833">
                  This Agreement will be governed by the laws of the State of
                  Connecticut without regard to any conflict of laws or
                  provisions. Any dispute shall be brought in the appropriate
                  state or federal court located in Fairfield County, and we and
                  you each irrevocably consent to the exclusive jurisdiction and
                  venue of the state or federal courts in Fairfield County,
                  Connecticut for the adjudication of all claims. The Parties
                  each waive any right to a jury trial.
                </p>
              </div>
              <div className="pt-4" data-id="element-834">
                <h2 className="font-poppins font-normal text-xl md:text-2xl text-black mb-4" data-id="element-835">
                  13. GENERAL INFORMATION
                </h2>
                <div className="space-y-4" data-id="element-836">
                  <div data-id="element-837">
                    <p className="font-medium mb-2" data-id="element-838">a) Notices.</p>
                    <p data-id="element-839">
                      Notices to Visitor may be made via either email or regular
                      mail. The Services may also provide notices of changes to
                      the Terms or other matters by displaying notices or links
                      to notices to Visitor generally on the Services or Sites.
                    </p>
                  </div>
                  <div data-id="element-840">
                    <p className="font-medium mb-2" data-id="element-841">b) Marketing.</p>
                    <p data-id="element-842">
                      HiddenMatter may use Visitor's name and logo in its
                      advertising and marketing materials to identify Visitor as
                      a HiddenMatter Visitor. Marketing services are only
                      provided in the English language unless indicated
                      otherwise. Textual training resources may be translated
                      into alternative languages for an additional fee.
                    </p>
                  </div>
                  <div data-id="element-843">
                    <p className="font-medium mb-2" data-id="element-844">c) Privacy.</p>
                    <p data-id="element-845">
                      We collect, store, and use Personal Data in accordance
                      with the Privacy Notice located on the Sites. We may use
                      non-Personal Data for any purposes as appropriate and
                      subject to applicable law.
                    </p>
                  </div>
                  <div data-id="element-846">
                    <p className="font-medium mb-2" data-id="element-847">
                      d) Entire Agreement; Construction; Severability.
                    </p>
                    <p data-id="element-848">
                      The Terms constitute the entire agreement between Visitor
                      and HiddenMatter and govern Visitor's use of the Services,
                      superseding any prior agreements between Visitor and
                      HiddenMatter. Visitor also may be subject to additional
                      terms and conditions that may apply when Visitor uses
                      affiliate services, third-party content, or third-party
                      software. The section titles in the Terms are for
                      convenience only and have no legal or contractual effect.
                      If any provision of the Terms is found by an arbitrator
                      and/or court of competent jurisdiction to be invalid, the
                      parties nevertheless agree that the arbitrator and/or
                      court should endeavor to give effect to the parties'
                      intentions as reflected in the provision, and the other
                      provisions of the Terms remain in full force and effect.
                    </p>
                  </div>
                  <div data-id="element-849">
                    <p className="font-medium mb-2" data-id="element-850">
                      e) Relationship of Parties.
                    </p>
                    <p data-id="element-851">
                      The parties are independent contractors, and this
                      Agreement does not and will not establish any relationship
                      of partnership, joint venture, employment, franchise, or
                      agency between the parties. Neither party has the power to
                      bind the other or incur obligations on the other's behalf.
                    </p>
                  </div>
                  <div data-id="element-852">
                    <p className="font-medium mb-2" data-id="element-853">
                      f) Third-Party Beneficiaries.
                    </p>
                    <p data-id="element-854">
                      HiddenMatter and Visitor agree that this Agreement is for
                      the benefit of HiddenMatter and Visitor, and is not
                      intended to confer any rights or benefits to any third
                      party. There are no third-party beneficiaries as to this
                      Agreement or any specific provision.
                    </p>
                  </div>
                  <div data-id="element-855">
                    <p className="font-medium mb-2" data-id="element-856">g) Assignment.</p>
                    <p data-id="element-857">
                      Visitor shall not assign this Agreement, or any of the
                      rights or obligations hereunder without HiddenMatter's
                      prior written consent. Any assignments will be null and
                      void and of no force or effect. This Agreement binds and
                      inures to the benefit of Visitor and HiddenMatter and
                      their respective permitted successors and permitted
                      assigns.
                    </p>
                  </div>
                  <div data-id="element-858">
                    <p className="font-medium mb-2" data-id="element-859">h) Force Majeure.</p>
                    <p data-id="element-860">
                      HiddenMatter shall not be liable to Visitor for any delay
                      or failure in the performance of its obligations hereunder
                      if and to the extent the delay or failure is due to events
                      beyond the reasonable control of the parties, including,
                      but not limited to, acts of God, strikes, pandemics or
                      epidemics, blockades, governmental orders, terrorism,
                      riots, natural disasters, internet and power outages, or
                      distortions.
                    </p>
                  </div>
                  <div data-id="element-861">
                    <p className="font-medium mb-2" data-id="element-862">i) Waiver.</p>
                    <p data-id="element-863">
                      The failure of HiddenMatter to exercise or enforce any
                      right or provision of the Terms shall not constitute any
                      kind of waiver of such right or provision.
                    </p>
                  </div>
                  <div data-id="element-864">
                    <p className="font-medium mb-2" data-id="element-865">j) Violations.</p>
                    <p data-id="element-866">
                      Please report any violations of the Terms to us at{' '}
                      <a href="mailto:chat@hiddenmatter.ai" className="text-black hover:text-lime transition-colors underline" data-id="element-867">
                        chat@hiddenmatter.ai
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Section>
      </main>
      <Footer data-id="element-868" />
    </div>;
}